export function scrollTop() {
    window.scrollTo(0, 0);
}
